export const getValue = (name: string, valueMap: Map<string, string>):number => {
    let result: number = 0
    result += valueMap[name]!=null ? Number(valueMap[name]) : 0

    return result;
}


// Check if a value is Even or Odd
export function isEven(value) {
	if (value%2 == 0)
		return true;
	else
		return false;
}